import React from "react";
import { createIntl, createIntlCache, RawIntlProvider } from "react-intl";
import { wrappedDisplayName } from "./utils/ReactUtil";
import { getLang, getMessages, getFormats } from "./i18n/i18nDataBuilder";
import PropTypes from "prop-types";

function flattenMessages(nestedMessages, prefix = "") {
	return Object.keys(nestedMessages).reduce((messages, key) => {
		const value = nestedMessages[key];
		const prefixedKey = prefix ? `${prefix}.${key}` : key;

		if (typeof value === "string") {
			messages[prefixedKey] = value;
		} else {
			Object.assign(messages, flattenMessages(value, prefixedKey));
		}

		return messages;
	}, {});
}

const flatMsgs = flattenMessages(getMessages());
export const intlProps = {
	locale: getLang(),
	messages: flatMsgs,
	formats: getFormats(),
};
const cache = createIntlCache();
export const intlRoot = createIntl(intlProps, cache);

export function withIntlRoot<P>(WrappedComponent: React.ComponentType<P>): React.ComponentType<P> {
	class Wrapper extends React.Component<P> {
		static contextTypes = {
			router: PropTypes.object,
		};
		static childContextTypes = {
			router: PropTypes.object,
			intl: PropTypes.object,
		};

		getChildContext() {
			return {
				router: (this.context as any).router,
				intl: intlRoot,
			};
		}

		render() {
			return (
				<RawIntlProvider value={intlRoot}>
					<WrappedComponent {...this.props} />
				</RawIntlProvider>
			);
		}
		static readonly displayName = wrappedDisplayName("withIntlRoot", WrappedComponent);
	}

	return Wrapper;
}
